@if (createNewUser) {
	<div class="mb-6 flex items-start lg:items-end">
		<div class="flex flex-1 flex-col gap-4">
			<div class="text-base font-bold text-black">Add New User</div>
		</div>
	</div>

	<form [formGroup]="createNewUser">
		<div class="mb-28 grid grid-cols-2 gap-4 gap-y-0">
			<div class="form-element">
				<mat-label for="form-name">Full Name</mat-label>
				<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
					<input
						type="text"
						formControlName="name"
						matInput
						placeholder="Full Name"
						class="uppercase"
					/>
					@if (name.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(name) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="form-element">
				<mat-label for="form-email">Email Address</mat-label>
				<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
					<input type="email" formControlName="email" matInput placeholder="Email Address" />
					<!-- tiny suffix spinner during lookup -->
					@if (loadingEmailLookup) {
						<mat-progress-spinner matSuffix diameter="16" mode="indeterminate"></mat-progress-spinner>
					}

					<!-- hint when found -->
					@if (workdayHitName) {
						<mat-hint>Found in Workday: {{ workdayHitName }}</mat-hint>
					}

					@if (email.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(email) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="form-element">
				<mat-label for="form-role">Role</mat-label>
				<mat-form-field appearance="outline" class="role-field form-field form-field-responsive mt-1 w-full">
					<mat-select formControlName="role" placeholder="Select Role" multiple>
						<mat-select-trigger>
							<mat-chip-set>
								@for (selectedRole of role.value; track selectedRole) {
									<mat-chip (removed)="removeRole(selectedRole)" [removable]="true">
										{{ getRoleDisplayName(selectedRole) }}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								}
							</mat-chip-set>
						</mat-select-trigger>

						@for (roleOption of rolesOptions; track roleOption) {
							<mat-option [value]="roleOption.code">{{ roleOption.code | titlecase }}</mat-option>
						}
					</mat-select>

					@if (role.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(role) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="form-element">
				<mat-label for="form-aoc">AOC</mat-label>
				<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
					<mat-select formControlName="aoc" placeholder="Select AOC">
						@for (aocOption of aocOptions; track aocOption) {
							<mat-option [value]="aocOption.code">{{ aocOption.description }}</mat-option>
						}
					</mat-select>
					@if (aoc.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(aoc) }}
						</mat-error>
					}
				</mat-form-field>
			</div>
			<div class="form-element">
				<mat-label for="form-external">User Type</mat-label>
				<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
					<mat-select formControlName="external" placeholder="Select User Type">
						<mat-option [value]="true">External</mat-option>
						<mat-option [value]="false">Internal</mat-option>
					</mat-select>
					@if (isExternal.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(isExternal) }}
						</mat-error>
					}
				</mat-form-field>
			</div>
		</div>

		<mat-divider></mat-divider>

		<div class="form-actions mt-9 flex flex-row justify-between">
			<div class="cancel-btn">
				<button (click)="goBack()" class="aa-btn" data-variant="tertiary" type="button">Cancel</button>
			</div>
			<div class="save-btn">
				<button class="aa-btn" data-variant="primary" type="button" (click)="onSubmit()">Create</button>
			</div>
		</div>
	</form>
}
